import { z } from 'zod';

export interface PaginatedResult<T> {
  readonly items: readonly T[];
  readonly pagination: {
    readonly cursor: string | null;
    readonly hasMore: boolean;
    readonly limit: number;
    readonly total?: number;
  };
}

export const ListSortOrderSchema = z.enum(['asc', 'desc']);
export type ListSortOrder = z.infer<typeof ListSortOrderSchema>;

export const PaginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export type PaginationInput = z.infer<typeof PaginationSchema>;

export const CursorPaginationMetaSchema = z.object({
  cursor: z.string().nullable(),
  hasMore: z.boolean(),
  limit: z.number().int().positive(),
  total: z.number().int().nonnegative().optional(),
});

export type CursorPaginationMeta = z.infer<typeof CursorPaginationMetaSchema>;
